var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eliminar",
    width: 21.313,
    height: 26.241,
    viewBox: "0 0 21.313 26.241",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M223.013,154.7a.615.615,0,0,0-.615.615v11.615a.615.615,0,1,0,1.229,0V155.318A.615.615,0,0,0,223.013,154.7Zm0,0",
    transform: "translate(-208.73 -145.196)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M105.013,154.7a.614.614,0,0,0-.615.615v11.615a.615.615,0,1,0,1.229,0V155.318A.614.614,0,0,0,105.013,154.7Zm0,0",
    transform: "translate(-97.982 -145.196)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M1.742,7.811V22.952a3.391,3.391,0,0,0,.9,2.338,3.026,3.026,0,0,0,2.2.949H16.467a3.026,3.026,0,0,0,2.2-.949,3.391,3.391,0,0,0,.9-2.338V7.811a2.348,2.348,0,0,0-.6-4.617H15.815V2.426A2.414,2.414,0,0,0,13.381,0H7.925A2.414,2.414,0,0,0,5.491,2.426v.768H2.344a2.348,2.348,0,0,0-.6,4.617Zm14.725,17.2H4.839a1.946,1.946,0,0,1-1.868-2.059V7.865H18.335V22.952a1.946,1.946,0,0,1-1.868,2.059ZM6.72,2.426a1.184,1.184,0,0,1,1.2-1.2h5.457a1.184,1.184,0,0,1,1.2,1.2v.768H6.72Zm-4.376,2H18.962a1.106,1.106,0,0,1,0,2.212H2.344a1.106,1.106,0,1,1,0-2.212Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M164.013,154.7a.615.615,0,0,0-.615.615v11.615a.615.615,0,1,0,1.229,0V155.318A.614.614,0,0,0,164.013,154.7Zm0,0",
    transform: "translate(-153.356 -145.196)",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.7004e6ea.svg";
export { ForwardRef as ReactComponent };